/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const REFRESH_SONG_MAIN_ALBUM_ID = 'REFRESH_SONG_MAIN_ALBUM_ID';
export const refreshSongMainAlbumId = actionCreator<Date>(REFRESH_SONG_MAIN_ALBUM_ID);
